import React from 'react';
import Box from '@/components/UI/box/Box';
import styles from './HomeSearchSkeleton.module.scss';
const HomeSearchSkeleton = () => {
  return <Box className={styles['container']} data-sentry-element="Box" data-sentry-component="HomeSearchSkeleton" data-sentry-source-file="HomeSearchSkeleton.tsx"></Box>;
};
export default HomeSearchSkeleton;